module.exports = __webpack_public_path__ + "img/health27_7-9-2021.78aef2da.jpg";